module.exports = __webpack_public_path__ + "static/media/hero_patient_de_text@2x.3bb2bc7b.png";